 import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../components/Product.css";
import { hasPermission } from "../utils/permissions";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [canView, setCanView] = useState(false);
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
// 🔹 Pagination
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 20; // change as needed
const pageLimit = 3; // how many numbers to show before ...

  // 🔹 Selected category (click-based)
  const [selectedCategory, setSelectedCategory] = useState("ALL");
const [categories, setCategories] = useState([]);

  const navigate = useNavigate();

  // Fetch permissions + products
  useEffect(() => {
    (async () => {
      try {
        const pView =
          (await hasPermission("master", "product")) ||
          (await hasPermission("master", "viewproduct"));
        const pAdd = await hasPermission("master", "addproduct");
        const pEdit = await hasPermission("master", "editproduct");

        setCanView(!!pView);
        setCanAdd(!!pAdd);
        setCanEdit(!!pEdit);
      } catch {
        setCanView(false);
        setCanAdd(false);
        setCanEdit(false);
      }
    })();

   const fetchProducts = async () => {
  try {
    const token = (localStorage.getItem("session_token") || "").trim();

    const response = await fetch(
      `https://newerp.awasthivitality.com/api/products/list${
        token ? `?token=${encodeURIComponent(token)}` : ""
      }`,
      {
        headers: {
          ...(token
            ? {
                Authorization: `Bearer ${token}`,
                "X-Session-Token": token,
              }
            : {}),
        },
      }
    );

    const result = await response.json();

    let productData = [];

    if (Array.isArray(result)) {
      productData = result;
    } else if (result.data && Array.isArray(result.data)) {
      productData = result.data;
    } else {
      throw new Error("Unexpected API response format");
    }
productData.sort((a, b) => b.product_id - a.product_id);

    setProducts(productData);
setCurrentPage(1); // always go to first page

    // ✅ Create category dropdown data here
    const uniqueCategories = [
      "ALL",
      ...new Set(productData.map((item) => item.category_name)),
    ];
    setCategories(uniqueCategories);

  } catch (err) {
    console.error("Error fetching products:", err);
    setError("write here you dont have to open this");
  } finally {
    setLoading(false);
  }
};

    fetchProducts();
  }, []);


  const handleAddClick = () => navigate("/NewProductEntry");
  const handleEditClick = (product_id) =>
    navigate(`/NewProductEdit/${product_id}`);

  // 🔹 Click category
//   const handleCategoryClick = (category) => {
//   setSelectedCategory(category);
//   setCurrentPage(1);
// };


  // DELETE FUNCTION
  const handleDelete = async (product_id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;

    try {
      const token = (localStorage.getItem("session_token") || "").trim();

      const response = await fetch(
        `https://newerp.awasthivitality.com/api/products/delete/${product_id}?token=${encodeURIComponent(
          token
        )}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Session-Token": token,
          },
        }
      );

      const result = await response.json();

      if (!response.ok) {
        alert(result.message || "Failed to delete product");
        return;
      }

      setProducts((prev) =>
        prev.filter((item) => item.product_id !== product_id)
      );

      alert("Product deleted successfully!");
    } catch (err) {
      console.error("Delete error:", err);
      alert("Error deleting product");
    }
  };

  // 🔹 Filter products by clicked category
  const filteredProducts =
    selectedCategory === "ALL"
      ? products
      : products.filter(
          (p) => p.category_name === selectedCategory
        );

  if (loading) {
    return (
      <div className="productlist-page">
        <h2>Loading products...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="productlist-page">
        <h2 style={{ color: "red" }}>{error}</h2>
      </div>
    );
  }

  if (!canView) {
    return (
      <div className="productlist-page">
        <h2>Access Denied</h2>
        <p>You do not have permission to view products.</p>
      </div>
    );
  }
  
const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
const getPageNumbers = () => {
  const pages = [];
  const total = totalPages;

  if (total <= 5) {
    // Small pages → show all
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }

  // Always show first page
  pages.push(1);

  // Show left dots
  if (currentPage > 3) {
    pages.push("...");
  }

  // Middle pages
  const start = Math.max(2, currentPage - 1);
  const end = Math.min(total - 1, currentPage + 1);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  // Show right dots
  if (currentPage < total - 2) {
    pages.push("...");
  }

  // Always show last page
  pages.push(total);

  return pages;
};


const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const paginatedProducts = filteredProducts.slice(
  indexOfFirstItem,
  indexOfLastItem
);

  return (
    <div className="productlist-page">
    <div className="productlist-header">
  <h2>Product List</h2>

  {/* 🔹 Category Dropdown */}
  <select
    value={selectedCategory}
    onChange={(e) => {
      setSelectedCategory(e.target.value);
      setCurrentPage(1);
    }}
    style={{
      marginLeft: "15px",
      padding: "6px 10px",
      borderRadius: "6px",
    }}
  >
    {categories.map((cat, index) => (
      <option key={index} value={cat}>
        {cat}
      </option>
    ))}
  </select>

  {canAdd && (
    <button className="productlist-adds-btn" onClick={handleAddClick}>
      +
    </button>
  )}
</div>


      <div className="productlist-table-container">
        <table className="productlist-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Category</th>
              <th>Name</th>
              <th>MRP</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
{paginatedProducts.map((p, index) => (
              <tr key={p.product_id}>
<td>{indexOfFirstItem + index + 1}</td>

                {/* 🔹 Clickable Category */}
              <td>{p.category_name}</td>


                <td>{p.product_name}</td>
                <td>{Number(p.mrp).toFixed(2)}</td>

                <td>
                  <button
                    className="productlist-edit-btn"
                    onClick={() => canEdit && handleEditClick(p.product_id)}
                    disabled={!canEdit}
                    style={{
                      opacity: canEdit ? 1 : 0.5,
                      cursor: canEdit ? "pointer" : "not-allowed",
                      marginRight: "6px",
                    }}
                  >
                    Edit
                  </button>

                  <button
                    className="productlist-delete-btn"
                    onClick={() => handleDelete(p.product_id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}

            {filteredProducts.length === 0 && (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No products found
                </td>
              </tr>
            )}
          </tbody>
        </table>
     <div className="pagination-container">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
  >
    Prev
  </button>

  {getPageNumbers().map((page, index) =>
    page === "..." ? (
      <span key={index} className="pagination-dots">...</span>
    ) : (
      <button
        key={index}
        className={currentPage === page ? "active" : ""}
        onClick={() => setCurrentPage(page)}
      >
        {page}
      </button>
    )
  )}

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage(currentPage + 1)}
  >
    Next
  </button>
</div>


      </div>
    </div>
  );
};

export default ProductList;